import { render, staticRenderFns } from "./PartnerTransferCheck.vue?vue&type=template&id=40950a5b&scoped=true&"
import script from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"
export * from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40950a5b",
  null
  
)

export default component.exports